import React, {Component} from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ListItem from '../../../content/components/social/list-item';

import { fetchSocial } from 'ActionsSocial';

class HeaderlinksContent extends Component {

  renderList(){
    var items=_.map( this.props.socials, social => <ListItem key={social.sociallinkid} social={social}/>);
    return items;
  }

  render(){
    return(
    <div className="social-content">
      <table className="table">
        <thead>
          <tr>
              <th>Link Text</th>
              <th>URL</th>
              <th>Open in New Tab</th>
              <th>Visible</th>
              <th>Action</th>
          </tr>
        </thead>
        <tbody className="tbody-background">
          <tr>
              <td>courses</td>
              <td>/courses</td>
              <td>  <label className="poll-switch" style={{margin: 0}}>
                        <input type="checkbox" />
                        <span className="poll-slider poll-round"></span>
                    </label></td>
              <td>
                    <label className="poll-switch" style={{margin: 0}}>
                        <input type="checkbox" />
                        <span className="poll-slider poll-round"></span>
                    </label>
              </td>
              <td><div className="action-button-area">
            <div className="action-button vcenter"><button className="btn btn-custom-table-white" >Edit</button></div>
            <div className="action-button vcenter">
              <button className="i-custom-table-delete">
                <img className="i-custom-table" src="../../style/images/custom-icons/shape-1317-copy-3.svg"/>
              </button>
            </div>
          </div></td>
          </tr>
          <tr>
              <td>Why Us</td>
              <td>/whyus</td>
              <td>  <label className="poll-switch" style={{margin: 0}}>
                        <input type="checkbox" />
                        <span className="poll-slider poll-round"></span>
                    </label></td>
              <td>  <label className="poll-switch" style={{margin: 0}}>
                        <input type="checkbox" />
                        <span className="poll-slider poll-round"></span>
                    </label></td>
              <td><div className="action-button-area">
            <div className="action-button vcenter"><button className="btn btn-custom-table-white" >Edit</button></div>
            <div className="action-button vcenter">
              <button className="i-custom-table-delete">
                <img className="i-custom-table" src="../../style/images/custom-icons/shape-1317-copy-3.svg"/>
              </button>
            </div>
          </div></td>
          </tr>
          <tr>
              <td>About Us</td>
              <td>/about</td>
              <td>  <label className="poll-switch" style={{margin: 0}}>
                        <input type="checkbox" />
                        <span className="poll-slider poll-round"></span>
                    </label></td>
              <td>  <label className="poll-switch" style={{margin: 0}}>
                        <input type="checkbox" />
                        <span className="poll-slider poll-round"></span>
                    </label></td>
              <td><div className="action-button-area">
            <div className="action-button vcenter"><button className="btn btn-custom-table-white" >Edit</button></div>
            <div className="action-button vcenter">
              <button className="i-custom-table-delete">
                <img className="i-custom-table" src="../../style/images/custom-icons/shape-1317-copy-3.svg"/>
              </button>
            </div>
          </div></td>
          </tr>
          <tr>
              <td>Pricing</td>
              <td>/pricing</td>
              <td>  <label className="poll-switch" style={{margin: 0}}>
                        <input type="checkbox" />
                        <span className="poll-slider poll-round"></span>
                    </label></td>
              <td>  <label className="poll-switch" style={{margin: 0}}>
                        <input type="checkbox" />
                        <span className="poll-slider poll-round"></span>
                    </label></td>
              <td><div className="action-button-area">
            <div className="action-button vcenter"><button className="btn btn-custom-table-white" >Edit</button></div>
            <div className="action-button vcenter">
              <button className="i-custom-table-delete">
                <img className="i-custom-table" src="../../style/images/custom-icons/shape-1317-copy-3.svg"/>
              </button>
            </div>
          </div></td>
          </tr>
        </tbody>

      </table>
    </div>
    );
  }
}


function mapStateToProps(state){
  return {
    socials: state.socials
  };
}

export default connect(mapStateToProps)(HeaderlinksContent);